import SearchableSelectCustom from '../../../../components/SearchableSelectCustom'
import { CustomerAuthInputField } from './CustomerAuthInputField'
import type { SignupContactStepProps } from './SignupContactStep.types'

type Props = Pick<
  SignupContactStepProps,
  | 'residentialAddressLabel'
  | 'contactDataSectionLabel'
  | 'addressStreetLabel'
  | 'addressStreetPlaceholder'
  | 'addressStreetNumberLabel'
  | 'addressStreetNumberPlaceholder'
  | 'addressCityLabel'
  | 'addressCityPlaceholder'
  | 'addressPostalCodeLabel'
  | 'addressPostalCodePlaceholder'
  | 'addressProvinceLabel'
  | 'addressProvincePlaceholder'
  | 'addressCountryLabel'
  | 'addressCountryPlaceholder'
  | 'countrySearchPlaceholder'
  | 'countryNoResultsLabel'
  | 'addressCountryOptions'
  | 'addressStreet'
  | 'addressStreetNumber'
  | 'addressCity'
  | 'addressPostalCode'
  | 'addressProvince'
  | 'addressCountry'
  | 'onAddressStreetChange'
  | 'onAddressStreetNumberChange'
  | 'onAddressCityChange'
  | 'onAddressPostalCodeChange'
  | 'onAddressProvinceChange'
  | 'onAddressCountryChange'
  | 'ui'
>

export const SignupContactAddressSection = ({
  residentialAddressLabel,
  contactDataSectionLabel,
  addressStreetLabel,
  addressStreetPlaceholder,
  addressStreetNumberLabel,
  addressStreetNumberPlaceholder,
  addressCityLabel,
  addressCityPlaceholder,
  addressPostalCodeLabel,
  addressPostalCodePlaceholder,
  addressProvinceLabel,
  addressProvincePlaceholder,
  addressCountryLabel,
  addressCountryPlaceholder,
  countrySearchPlaceholder,
  countryNoResultsLabel,
  addressCountryOptions,
  addressStreet,
  addressStreetNumber,
  addressCity,
  addressPostalCode,
  addressProvince,
  addressCountry,
  onAddressStreetChange,
  onAddressStreetNumberChange,
  onAddressCityChange,
  onAddressPostalCodeChange,
  onAddressProvinceChange,
  onAddressCountryChange,
  ui,
}: Props) => (
  <section className="space-y-3">
    <h2 className="text-sm font-semibold tracking-tight text-(--color-text-primary)">{residentialAddressLabel}</h2>
    <p className="text-xs text-(--color-text-muted)">{contactDataSectionLabel}</p>
    <div className="grid gap-2.5 md:grid-cols-2">
      <CustomerAuthInputField
        field="addressStreet"
        label={addressStreetLabel}
        value={addressStreet}
        onChange={onAddressStreetChange}
        placeholder={addressStreetPlaceholder}
        required
        ui={ui}
      />
      <CustomerAuthInputField
        field="addressStreetNumber"
        label={addressStreetNumberLabel}
        value={addressStreetNumber}
        onChange={onAddressStreetNumberChange}
        placeholder={addressStreetNumberPlaceholder}
        required
        ui={ui}
      />
    </div>
    <div className="grid gap-2.5 md:grid-cols-2">
      <CustomerAuthInputField
        field="addressCity"
        label={addressCityLabel}
        value={addressCity}
        onChange={onAddressCityChange}
        placeholder={addressCityPlaceholder}
        required
        ui={ui}
      />
      <CustomerAuthInputField
        field="addressPostalCode"
        label={addressPostalCodeLabel}
        value={addressPostalCode}
        onChange={onAddressPostalCodeChange}
        placeholder={addressPostalCodePlaceholder}
        normalizeValue={(value) => value.toUpperCase()}
        extraClassName="uppercase"
        required
        ui={ui}
      />
      <CustomerAuthInputField
        field="addressProvince"
        label={addressProvinceLabel}
        value={addressProvince}
        onChange={onAddressProvinceChange}
        placeholder={addressProvincePlaceholder}
        normalizeValue={(value) => value.toUpperCase()}
        extraClassName="uppercase"
        required
        maxLength={3}
        ui={ui}
      />
      <label className="grid min-w-0 gap-1 text-sm font-medium text-(--color-text-secondary)">
        <span>
          {addressCountryLabel}
          {ui.fieldLabelRequiredMark}
        </span>
        <SearchableSelectCustom
          value={addressCountry}
          onChange={onAddressCountryChange}
          onBlur={() => ui.onFieldBlur('addressCountry')}
          ariaLabel={addressCountryPlaceholder}
          ariaInvalid={Boolean(ui.resolveFieldError('addressCountry'))}
          describedById={ui.resolveErrorDescribedBy('addressCountry')}
          placeholder={addressCountryPlaceholder}
          searchPlaceholder={countrySearchPlaceholder}
          emptyLabel={countryNoResultsLabel}
          options={addressCountryOptions}
          buttonClassName={ui.resolveSelectClassName('addressCountry')}
        />
        {ui.renderFieldHint('addressCountry')}
      </label>
    </div>
  </section>
)
